// tslint:disable
export enum TCSPromotionSearchScope {
    /**
     * @description Search within brand
     */
    Brand = 0,
    /**
     * @description Search within the entire program that the promotion is associated with
     */
    ProgramId = 1,
    /**
     * @description Search within promotion group
     */
    PromotionGroup = 2,
}
(TCSPromotionSearchScope as any)['BRAND'] = 0;
(TCSPromotionSearchScope as any)['PROGRAMID'] = 1;
(TCSPromotionSearchScope as any)['PROMOTIONGROUP'] = 2;
